import Product from '~/models/Product/Product'
import FullProduct from '~/models/Product/FullProduct'

export const transformProductToFullProduct = (product: Product): FullProduct => {
    return {
        id: product.id,
        name: product.name,
        price: product.price,
        priceNoVat: product.priceNoVat,
        originalPriceNoVat: product.originalPriceNoVat,
        percentDiscount: product.percentDiscount,
        percentDiscountForAddonSalePrice: null,
        lowestPrice: product.lowestPrice,
        vat: 0,
        absoluteDiscount: 0,
        priceBeforeDiscount: product.priceBeforeDiscount,
        availabilityPeriod: product.availabilityPeriod,
        amountInStock: product.amountInStock,
        availabilityModalEnabled: product.availabilityModalEnabled,
        rate: product.rate,
        image: product.image,
        imageCdn: product.image,
        images: [],
        imagesOverviews: [],
        status: product.status,
        isAvailable: product.isAvailable,
        hasExpiration: product.hasExpiration,
        advantage: 0,
        packSize: null,
        // @ts-ignore
        attributes: {
            machineLearningAddOnProducts: [],
        },
        content: {
            short: product.description,
            long: '',
            shortNoFullHtml: product.description,
            longNoFullHtml: '',
            spc: null,
            gift: null,
            files: [],
        },
        ingredientsText: null,
        averageRating: product.averageRating,
        basicAdvantage: 0,
        brandId: null,
        productLineId: null,
        supplierId: null,
        manufacturerId: null,
        pharmacyIds: [],
        categoryIds: [],
        url: product.url,
        isVisibleOnWeb: true,
        categoryBestsellerScore: 0,
        keywords: [],
        mainCategoryId: null,
        isPrescriptionOnly: false,
        benefitPaymethodEnabled: true,
        breadcrumbs: [],
        deliveries: [],
        fastestDeliveryDate: '',
        fastestDeliveryDateSimple: '',
        visualTags: {
            productVisualTagsAsBenefits: product.visualTags.productVisualTagsAsBenefits,
            productVisualTagsBadges: product.visualTags.productVisualTagsBadges,
            merged: product.visualTags.merged,
        },
        similarProducts: [],
        productVariants: {
            variantGroups: [],
            variantsCount: product.variantsCount,
            minimalPrice: 0,
            recommendedVariantUrl: '',
            variantEans: [],
        },
        giftActions: [],
        brandName: product.brandName,
        manufacturerName: product.manufacturerName,
        categoryNames: product.categoryNames,
        substitutions: null,
        brand: null,
        manufacturer: null,
        productLine: null,
        supplier: null,
        amountPrices: [],
        comments: {
            total: product.productRating?.averageRating || 0,
            commentCount: product.productRating?.totalReviews || 0,
            items: [],
            rating: product.productRating?.averageRating || 0,
            ratingsCounts: {
                1: product.productRating?.oneStars || 0,
                2: product.productRating?.twoStars || 0,
                3: product.productRating?.threeStars || 0,
                4: product.productRating?.fourStars || 0,
                5: product.productRating?.fiveStars || 0,
            },
            recommendPercent: product.productRating?.recommendPercentage || 0,
            questionRatings: [],
            comments: [],
        },
        additionalInformation: [],
        addonSaleAreas: [],
        productCertificates: [],
        metaDescription: '',
        boxPickupAvailabilityText: '',
        carPickupAvailabilityText: '',
        pharmacyPickupAvailabilityText: '',
        additionalProducts: [],
        seoText: '',
        cashback: null,
        productRating: product.productRating,
        clickAndCollectData: null,
        productCodeSale: null,
        isPreorder: false,
        mobileAppPrice: null,
        mobileAppPriceForLoggedInUser: null,
        mobileAppAction: null,
        hasMobileAppAction: false,
        hasCompetitorSuperPrice: false,
        pharmacyDealPrice: null,
        deposit: null,
        pricePerPiece: null,
        xmasDelivery: null,
        showCounsellingBanner: false,
        service: null,
        categoryText: '',
        desktopBanner: '',
        hasIdleSellingSettingsStatus: false,
        mobileBanner: '',
        redirectTo: '',
        showFreeShippingInAppUSP: false,
        shippings: [],
        productMonthlyPackages: [],
    }
}
